import { render } from "./EditAudioFeatureModal.vue?vue&type=template&id=4f2ed05a"
import script from "./EditAudioFeatureModal.vue?vue&type=script&lang=js"
export * from "./EditAudioFeatureModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4f2ed05a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f2ed05a', script)) {
    api.reload('4f2ed05a', script)
  }
  
  module.hot.accept("./EditAudioFeatureModal.vue?vue&type=template&id=4f2ed05a", () => {
    api.rerender('4f2ed05a', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/AudioGuide/EditAudioFeatureModal.vue"

export default script